var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.5L5.5 6.5M5.5 3.5L8.5 6.5M1.36 5.48L3.52 8.36C3.696 8.59467 3.784 8.712 3.89552 8.79662C3.9943 8.87158 4.10616 8.9275 4.22539 8.96155C4.36 9 4.50667 9 4.8 9H8.6C9.44008 9 9.86012 9 10.181 8.83651C10.4632 8.6927 10.6927 8.46323 10.8365 8.18099C11 7.86012 11 7.44008 11 6.6V3.4C11 2.55992 11 2.13988 10.8365 1.81901C10.6927 1.53677 10.4632 1.3073 10.181 1.16349C9.86012 1 9.44008 1 8.6 1H4.8C4.50667 1 4.36 1 4.22539 1.03845C4.10616 1.0725 3.9943 1.12842 3.89552 1.20338C3.784 1.288 3.696 1.40533 3.52 1.64L1.36 4.52C1.2309 4.69213 1.16635 4.77819 1.14147 4.87272C1.11951 4.95615 1.11951 5.04385 1.14147 5.12728C1.16635 5.22181 1.2309 5.30787 1.36 5.48Z",
    stroke: "#4E5BA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAll);
export default __webpack_public_path__ + "static/media/clear-all.75325d68174adbfa4917576db6a9eff1.svg";
export { ForwardRef as ReactComponent };